var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinimapSelectedBelowAllAncestorsBetweenDescendents = function SvgMinimapSelectedBelowAllAncestorsBetweenDescendents(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6B7280",
    strokeWidth: 2,
    d: "M27 12h-5M11 0v10a2 2 0 0 0 2 2h3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 12,
    r: 2.5,
    stroke: "#4F46E5",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6B7280",
    strokeWidth: 2,
    d: "M27 0v24"
  })));
};
export default SvgMinimapSelectedBelowAllAncestorsBetweenDescendents;